import React from "react"
import TitleVideo from "../../../common/sections/title-video/TitleVideoSection"
function CtxRhJobSectorTitleVideo({title, baseline, video}) {
 return <TitleVideo title={title} baseline={baseline} imageVideoData={video}/>
}
export const name = "CtxRhJobSectorTitleVideo"

export const init = (componentData, pageContext) => {
  return (
    <CtxRhJobSectorTitleVideo
      key={componentData.id}    
      title={pageContext.itemData?.attributes?.pageTitle}
      baseline={pageContext.itemData?.attributes?.baseline}
      video={pageContext.itemData?.attributes?.media}
    />
  )
}

export default CtxRhJobSectorTitleVideo
